// extracted by mini-css-extract-plugin
export default {"mainBlock":"mainBlock_mainBlock__z4+vH","rightSide":"mainBlock_rightSide__Ut8ke"};